import React, { useEffect, useState } from "react";
import { fetchReportGoals } from "../../../services/httpClient";
import { formatDateTimeToLocal } from "../../../helpers/date";
import DataTable from "../ui/DataTable";

interface GoalsCompletedTableState {
  data?: any[];
  startDate?: string;
  endDate?: string;
  useDatePicker?: boolean;
}

export const GoalsCompletedTable = ({ data, startDate, endDate, useDatePicker = false }: GoalsCompletedTableState) => {
  const [goalData, setGoalData] = useState<any>([]);

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case Name", key: "case_name" },
    { label: "ID", key: "id", hide: true },
    { label: "Goal", key: "goal_name" },
    { label: "Assigned To", key: "subject.name" },
    { label: "Completed", key: "completed_at_formatted" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (data || data === 0) {
        setGoalData(data as any[]);
      } else {
        const starting = new Date();
        starting.setDate(starting.getDate() - 365);
        let start = starting.toISOString().slice(0, 10);
        let end = new Date().toISOString().slice(0, 10);
        if (useDatePicker) {
          start = startDate ?? start;
          end = endDate ?? end;
        }
        await getGoalData(start!, end!);
      }
    };
    fetchData();
  }, [data, startDate, endDate, useDatePicker]);

  const getGoalData = async (start: string, end: string) => {
    fetchReportGoals(start, end)
      .then((res: any) => {
        const goals = res[0].data;
        const sortedGoals = goals.sort((a: any, b: any) => (a.completed_at < b.completed_at ? 1 : -1));
        sortedGoals.forEach((goal: any) => {
          if (goal?.completed_at) {
            const localDateTime = formatDateTimeToLocal(goal.completed_at);
            goal.completed_at_formatted = localDateTime.date + " " + localDateTime.time;
          }
          if (goal?.created_at) {
            const localDateTime = formatDateTimeToLocal(goal.created_at);
            goal.created_at_formatted = localDateTime.date + " " + localDateTime.time;
          }
        });
        const completed = sortedGoals.filter((g: any) => g.completed_at);
        setGoalData(completed);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return goalData && goalData.length > 0 ? (
    <DataTable tableHeadings={tableHeaders} tableData={goalData} title={"Goals Completed"} />
  ) : (
    <p>No Goals Completed Records</p>
  );
};
